import React from 'react';

export default function Documentation() {
  return (
    <div className="flex h-[27rem] flex-col rounded-lg bg-white p-6">
      <p className="text-sm font-medium text-primary-800">Documentation</p>
      <div className="mt-6">
        <p className="text-sm font-medium underline">Copy of means of ID</p>
        <p className="my-6 text-sm font-medium underline">
          Utility Bill/Proof of Address
        </p>
      </div>
    </div>
  );
}
